import { render, staticRenderFns } from "./DropdownEdit.vue?vue&type=template&id=c4fea808&scoped=true&"
import script from "./DropdownEdit.vue?vue&type=script&lang=js&"
export * from "./DropdownEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fea808",
  null
  
)

export default component.exports